import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
import iconSrc from '@/assets/images/edit/config/m-lef-matrixmultiselection@2x.png'
export default {
  id: '',
  groupId: '',
  belongId: '',
  isRequired: '1',
  orderById: 90,
  elementType: 'CheckBoxGroup',
  elementDesc: '矩阵多选',
  type: 'checkboxgroup',
  // 是否可配置
  config: true,
  title: '矩阵多选',
  placeholder: '矩阵多选',
  itemName: 'optionList',
  // 选项内数据
  descList: [{
    orderById: '1',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }],
  optionList: [{
    orderById: '1',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }, {
    orderById: '2',
    optionName: '',
    type: 'normal',
    imgUrl: '',
    imgName: ''
  }],
  vertical: true,
  value: [],
  otherAnswer: '',
  ruleError: '该字段不能为空',
  // 选项随机排列   0顺序排列1随机排列2循环显示
  randOrder: '0',
  saveUrl: '/design/qu-checkbox-group/ajaxSave.do',
  iconStyle: {
    width: '11px',
    height: '11px',
    background: 'url(' + iconSrc + ')'
  },
  saveFn () {
    return quSave({
      descList: util.genList(this.descList),
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.exclusiveItemsId = data.exclusiveItemsId ? data.exclusiveItemsId.split(',') : []
    this.mutualItemsId = data.mutualItemsId ? data.mutualItemsId.split(',') : []
    this.descList = util.genRetList.call(this, data.descList, 'desc', { value: [], otherAnswer: '' })
    this.optionList = util.genRetList.call(this, data.optionList, 'option')
  },
  getAnswer () {
    const answer = []
    this.descList.forEach(item => {
      answer.push({
        belongId: this.belongId,
        quId: this.id,
        belongAnswerId: this.belongAnswerId,
        quRowId: item.id,
        quColId: item.value.join(',')
      })
    })
    return answer
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/CheckBoxGroup/config.js